<template>
    <div class="container">
        <b-modal
            :model-value="modalEditar"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            size="xl"
            dialog-class="modal-detalle-financiera-wide"
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >

            <div class="uniform-modal-body uniform-modal-body--wide">

                <!-- TÍTULO / INFORMACIÓN -->
                <div class="password-policy-box mb-3">
                    <!-- <div class="password-policy-title">
                        {{ labels.infoTitle }}
                    </div> -->

                    <div class="password-policy-item">
                        {{ labels.vigencia }}:
                        {{ infoFinanciera?.vigencia?.slice(0, 7) || '' }}
                    </div>
                </div>


                <!-- ====================================== -->
                <!-- MENÚ LATERAL + CONTENIDO -->
                <!-- ====================================== -->

                <div class="menu-association-layout">

                    <!-- ================================== -->
                    <!-- MENÚ IZQUIERDO -->
                    <!-- ================================== -->

                    <div class="menu-sidebar">

                        <!-- Constantes -->
                        <b-button
                            @click="constantes"
                            class="menu-sidebar-item"
                            :class="{
                                active: vistaActiva === 'constantes'
                            }"
                        >
                            {{ labels.constantes }}
                        </b-button>
                        
                        
                        <!-- Financiera -->
                        <b-button
                            @click="editarInfoFinanciera"
                            class="menu-sidebar-item"
                            :class="{
                                active: vistaActiva === 'editar'
                            }"
                        >
                            {{ labels.editar }}
                        </b-button>


                        <!-- Score -->
                        <b-button
                            @click="cifrasInfoFinanciera"
                            class="menu-sidebar-item"
                            :class="{
                                active: vistaActiva === 'cifras'
                            }"
                        >
                            {{ labels.cifras }}
                        </b-button>


                        <!-- Variables -->
                        <b-button
                            @click="clasificacion"
                            class="menu-sidebar-item"
                            :class="{
                                active: vistaActiva === 'clasificacion'
                            }"
                        >
                            {{ labels.clasificacion }}
                        </b-button>


                        <!-- Tasas -->
                        <b-button
                            @click="calificacionTasas"
                            class="menu-sidebar-item"
                            :class="{
                                active: vistaActiva === 'tasas'
                            }"
                        >
                            {{ labels.tasas }}
                        </b-button>

                    </div>


                    <!-- ================================== -->
                    <!-- CONTENIDO DERECHO -->
                    <!-- ================================== -->

                    <div class="menu-content">

                        <!-- Título del contenido -->
                        <div class="menu-content-title">

                            <span v-if="vistaActiva === 'editar'">
                                {{ labels.editar }}
                            </span>

                            <span v-else-if="vistaActiva === 'cifras'">
                                {{ labels.cifras }}
                            </span>

                            <span v-else-if="vistaActiva === 'constantes'">
                                {{ labels.constantes }}
                            </span>

                            <span v-else-if="vistaActiva === 'clasificacion'">
                                {{ labels.clasificacion }}
                            </span>

                            <span v-else-if="vistaActiva === 'tasas'">
                                {{ labels.tasas }}
                            </span>

                            <span v-else>
                                {{ labels.selectMenuHint }}
                            </span>

                        </div>


                        <!-- ================================== -->
                        <!-- FINANCIERA -->
                        <!-- ================================== -->

                        <div
                            v-if="vistaActiva === 'editar'"
                            class="contenido-componente"
                        >
                            <Modificar
                                :infoFinanciera="infoFinanciera"
                            />
                        </div>


                        <!-- ================================== -->
                        <!-- SCORE -->
                        <!-- ================================== -->

                        <div
                            v-else-if="vistaActiva === 'cifras'"
                            class="contenido-componente"
                        >
                            <Cifras
                                :infoFinanciera="infoFinanciera"
                                :infoConstante="infoConstante"
                                :saveScore="true"
                            />
                        </div>


                        <!-- ================================== -->
                        <!-- CONSTANTES -->
                        <!-- ================================== -->

                        <div
                            v-else-if="vistaActiva === 'constantes'"
                            class="contenido-componente"
                        >
                            <Constantes
                                :infoVigencia="infoFinanciera?.vigencia"
                            />
                        </div>


                        <!-- ================================== -->
                        <!-- VARIABLES -->
                        <!-- ================================== -->

                        <div
                            v-else-if="vistaActiva === 'clasificacion'"
                            class="contenido-componente"
                        >
                            <Clasificacion
                                :infoVigencia="infoFinanciera?.vigencia"
                            />
                        </div>


                        <!-- ================================== -->
                        <!-- TASAS -->
                        <!-- ================================== -->

                        <div
                            v-else-if="vistaActiva === 'tasas'"
                            class="contenido-componente"
                        >
                            <Tasas
                                :infoVigencia="infoFinanciera?.vigencia"
                            />
                        </div>


                        <!-- ================================== -->
                        <!-- SIN SELECCIÓN -->
                        <!-- ================================== -->

                        <div
                            v-else
                            class="no-submenus"
                        >
                            {{ labels.selectMenuHint }}
                        </div>

                    </div>

                </div>


                <!-- ====================================== -->
                <!-- BOTÓN CERRAR -->
                <!-- ====================================== -->

                <div
                    class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap"
                >
                    <b-button
                        class="reset-btn-secondary"
                        @click="cierraModal"
                    >
                        {{ labels.close }}
                    </b-button>
                </div>

            </div>

        </b-modal>
    </div>
</template>


<script>

import Cifras from './Cifras.vue'
import Modificar from './Modificar.vue'
import Clasificacion from './Clasificacion.vue'
import Tasas from './Tasas.vue'
import Constantes from './Constantes.vue'

export default {

    name: 'Detalle',

    props: {
        modalEditar: {
            type: Boolean,
            default: false
        },

        infoFinanciera: {
            type: Object,
            default: () => ({})
        },

        infoConstante: {
            type: Object,
            default: () => ({})
        }
    },

    components: {
        Cifras,
        Modificar,
        Clasificacion,
        Tasas,
        Constantes
    },

    data() {
        return {
            vistaActiva: null
        }
    },

    computed: {

        labels() {

            if (this.$store.state._language === 'es-ES') {

                return {

                    title: 'Zscore',

                    close: 'Cerrar',

                    infoTitle: 'Información financiera',

                    vigencia: 'Vigencia',

                    menuListTitle: 'Opciones',

                    editar: 'Financiera',

                    cifras: 'Score',

                    constantes: 'Constantes',

                    clasificacion: 'Variables',

                    tasas: 'Tasas',

                    selectMenuHint:
                        'Selecciona una opción del menú'

                }

            } else {

                return {

                    title: 'Zscore',

                    close: 'Close',

                    infoTitle: 'Financial information',

                    vigencia: 'Validity',

                    menuListTitle: 'Options',

                    editar: 'Financial information',

                    cifras: 'Score',

                    constantes: 'Constants',

                    clasificacion: 'Variables',

                    tasas: 'Rates',

                    selectMenuHint:
                        'Select an option from the menu'

                }
            }
        }
    },

    methods: {

        editarInfoFinanciera() {

            this.vistaActiva = 'editar'

        },


        cifrasInfoFinanciera() {

            this.vistaActiva = 'cifras'

        },


        constantes() {

            this.vistaActiva = 'constantes'

        },


        clasificacion() {

            this.vistaActiva = 'clasificacion'

        },


        calificacionTasas() {

            this.vistaActiva = 'tasas'

        },


        cierraModal() {

            this.vistaActiva = null

            this.$emit('cierraModal', false)

        }

    }

}
</script>


<style scoped>

/* ========================================= */
/* MODAL GRANDE */
/* ========================================= */

.modal-detalle-financiera-wide {
    max-width: 1100px !important;
    width: 95%;
}


/* ========================================= */
/* LAYOUT PRINCIPAL */
/* ========================================= */

.menu-association-layout {
    display: flex;
    width: 100%;
    min-height: 520px;
}


/* ========================================= */
/* MENÚ LATERAL */
/* ========================================= */

.menu-sidebar {
    width: 200px;
    min-width: 200px;

    padding: 10px;

    display: flex;
    flex-direction: column;

    gap: 6px;

    border-right: 1px solid #dee2e6;

    background-color: #F2F8FF;
}


.menu-sidebar-title {
    font-size: 14px;
    font-weight: 600;

    padding: 8px 10px 12px;

    color: #495057;
}


/* ========================================= */
/* BOTONES DEL MENÚ */
/* ========================================= */

.menu-sidebar-item {
    width: 100%;

    text-align: left;

    border: none;

    border-radius: 6px;

    background-color: transparent;

    color: #495057;

    padding: 10px 12px;

    font-size: 13px;

    transition: all 0.2s ease;
}


.menu-sidebar-item:hover {
    background-color: #e9ecef;

    color: #212529;
}


.menu-sidebar-item.active {
    background-color: #016690;

    color: #ffffff;

    font-weight: 500;
}


/* ========================================= */
/* CONTENIDO DERECHO */
/* ========================================= */

.menu-content {
    flex: 1;

    min-width: 0;

    padding: 15px 20px;

    overflow-y: auto;

    max-height: 520px;
}


.menu-content-title {
    text-align: center;

    font-size: 20px;

    font-weight: 600;

    padding-bottom: 12px;

    margin-bottom: 15px;

    border-bottom: 1px solid #dee2e6;
}


.contenido-componente {
    width: 100%;
}


/* ========================================= */
/* SIN SELECCIÓN */
/* ========================================= */

.no-submenus {

    min-height: 400px;

    display: flex;

    align-items: center;

    justify-content: center;

    text-align: center;

    color: #6c757d;

    font-size: 14px;
}


/* ========================================= */
/* RESPONSIVE */
/* ========================================= */

@media (max-width: 768px) {

    .menu-association-layout {
        flex-direction: column;
    }

    .menu-sidebar {
        width: 100%;
        min-width: 100%;

        border-right: none;

        border-bottom: 1px solid #dee2e6;
    }

    .menu-content {
        max-height: none;

        padding: 15px 5px;
    }

    .modal-detalle-financiera-wide {
        width: 98%;
    }

}

</style>